/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { SliderSlotProps } from "../types";

export const DefaultSlider: React.FC<SliderSlotProps> = ({
  value,
  min = 0,
  max = 100,
  step = 1,
  onChange,
  className,
  vertical,
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledBy,
  "aria-valuetext": ariaValueText,
}) => {
  return (
    <input
      type="range"
      className={`player-default-slider${vertical ? " vertical" : ""} ${
        className || ""
      }`}
      value={value}
      min={min}
      max={max}
      step={step}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      aria-valuetext={ariaValueText}
      onChange={(e) => onChange?.(Number(e.target.value))}
    />
  );
};
